import { render, staticRenderFns } from "./LearnRecordDetail.vue?vue&type=template&id=6bdffb78&scoped=true&"
import script from "./LearnRecordDetail.vue?vue&type=script&lang=js&"
export * from "./LearnRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./LearnRecordDetail.vue?vue&type=style&index=0&id=6bdffb78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdffb78",
  null
  
)

export default component.exports